import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DataHandler } from 'C4';
import img from '../../assets/images/bg.jpg';

export default class BackImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: null,
    };
  }

  componentWillMount() {
    DataHandler.matchAppId()
      // .then(appId => this.setState({ image: `https://s3.amazonaws.com/developertool/${appId}/bg.jpg` }));
      .then(appId => this.setState({ image: img }));
  }

  render() {
    const { image } = this.state;
    const { blur, darken } = this.props;

    return (
      <div>
        {image &&
          <div
            style={{ backgroundImage: `url("${image}")` }}
            className={`backgroundImage ${blur && 'blur'} ${darken && 'darken'}`}
          />}
      </div>
    );
  }
}

BackImage.propTypes = {
  blur: PropTypes.bool,
  darken: PropTypes.bool,
};

BackImage.defaultProps = {
  blur: false,
  darken: false,
};
